import { VendorDetailsPayload, VendorUrlPayload } from "../modules/home/home.model";
import SendRequest from "../services/sendRequest.service";



export const healthBenefitsApi = async () => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/beneficiary/healthBenefits`;
  const response = await SendRequest.instance.post(url, null);
  return response;
};

export const healthCheckPartnerServices = async (payload: VendorDetailsPayload) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/beneficiary/vendors`;
  const response = await SendRequest.instance.post(url, payload);
  return response;
};


export const vendorlUrlApi = async (payload: VendorUrlPayload) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/beneficiary/vendorUrl`;
  const response = await SendRequest.instance.post(url, payload);
  return response;
};

export const redirectUrl = async (payload: VendorUrlPayload) => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/getRedirectUrl`;
  const response = await SendRequest.instance.post(url, payload);
  return response;
};

export const tokenApiUrl = async() => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/profile/auth-token`;
  const response = await SendRequest.instance.get(url);
  return response;
}
